import { render } from "./AlarmMailToSetting.vue?vue&type=template&id=daf643b0"
import script from "./AlarmMailToSetting.vue?vue&type=script&lang=js"
export * from "./AlarmMailToSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__